import React from 'react';
import { Button, Modal, Form } from 'semantic-ui-react'
import AppComponent from './app_component'
import { getFormLabelTranslations } from '../helpers';

class DeleteRiskModal extends AppComponent {
  constructor(props){
    super(props)

    this.state.formKeys = this.getRequiredFormKeys()
    
  }

  createDetail = (title, text, editable, key) => {
    return (
      <div key={key} className={ "delete-modal-component " + editable }>
        <div className="delete-modal-component title">{ title }</div>
        <div className="delete-modal-component text">{ text }</div>
      </div>
    )
  }

  modalDetails = () => {
    const { delete_activity_note, delete_hazard_note } = this.props.translations
    const { risk } = this.props
    const { formKeys } = this.state
    const formLabelTranslations = getFormLabelTranslations();
    var details = []
    
    formKeys.map((key, index)=>{
      if(risk.column==='work_phase'){
        if (key.includes('work_phase')) {
          details.push(this.createDetail(formLabelTranslations[key], risk[key], risk.is_custom==='work_phase', index))
          details.push(<div key={index+1} className="delete-modal-component warning">Note: This will delete all Activities, Hazards and Unwanted Events under "{ risk[key] }"</div>)
          return
        }
      }

      if(risk.column==='activity'){
        if (key.includes('work_phase')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], risk.is_custom==='work_phase', index))
        if (key.includes('activity')) {
          details.push(this.createDetail(formLabelTranslations[key], risk[key], ['work_phase','activity'].includes(risk.is_custom), index))
          details.push(<div key={index+1} className="delete-modal-component warning">{delete_activity_note} "{ risk[key] }"</div>)
          return 
        }
      }

      if(risk.column==='hazard'){
        if (key.includes('work_phase')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], risk.is_custom==='work_phase', index))
        if (key.includes('activity')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], ['work_phase','activity'].includes(risk.is_custom), index))
        if (key.includes('hazard')) {
          details.push(this.createDetail(formLabelTranslations[key], risk[key], ['work_phase','activity', 'hazard'].includes(risk.is_custom), index))
          details.push(<div key={index+1} className="delete-modal-component warning">{delete_hazard_note} "{ risk[key] }"</div>)
          return 
        }
      }

      if(risk.column==='unwanted_event'){
        if (key.includes('work_phase')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], risk.is_custom==='work_phase', index))
        if (key.includes('activity')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], ['work_phase','activity'].includes(risk.is_custom), index))
        if (key.includes('hazard')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], ['work_phase','activity', 'hazard'].includes(risk.is_custom), index))
        if (key.includes('unwanted_event')) return details.push(this.createDetail(formLabelTranslations[key], risk[key], true, index))
      }
    
    })

    return details
  }

  onDelete = () => {
    this.props.onDelete(this.props.risk)
  }

  render() {
    const confirm_delete = this.props.translations.confirm_delete
    const delete_label = this.props.translations.delete
    return (
      <Modal size="tiny" open={ this.props.shown } onClose={ this.props.onClose }>
        <Modal.Header>{confirm_delete}</Modal.Header>
        <Modal.Content>
          <Form>
            { this.modalDetails() }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' fluid size='medium' onClick={ () => this.onDelete() } className="new-plan-button">{delete_label}</Button>
        </Modal.Actions>
        <i className="delete icon" onClick={ this.props.onClose }></i>
      </Modal>
    )
  }
}

export default DeleteRiskModal



// WEBPACK FOOTER //
// ./src/components/delete_risk_modal.js